import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Typography from '@material-ui/core/Typography';
import IconCross from 'components/icons/IconCross';

import IconButton from 'components/common/IconButton';

import splitLongWords from 'utils/splitLongWords';

const styles = () => ({
  root: {
    padding: 0,
    display: 'block',
    marginTop: 20,
  },
  listItemSecondaryAction: {
    top: 10,
    right: -15,
  },
  iconCross: {
    width: 11,
    height: 11,
  },
  typographyName: {
    paddingRight: 30,
  },
});

const OrderInformationSalesRepresentativeField = ({
  input,
  classes,
  disabled,
  onRemove,
  ...otherProps
}) => {
  const salesRepresentativeItem = otherProps['Sales Representative']
    .find(item => item.ID === input.value);
  return (
    <ListItem
      className={classes.root}
      disableGutters
    >
      <Typography
        className={classes.typographyName}
        component="span"
        gutterBottom
      >
        {splitLongWords(`${salesRepresentativeItem['First Name']}
          ${salesRepresentativeItem['Last Name']}`, 25)}
      </Typography>
      <Typography
        variant="caption"
        component="span"
      >
        {salesRepresentativeItem.Email
          ? splitLongWords(`${salesRepresentativeItem.Phone} ${salesRepresentativeItem.Email}`)
          : salesRepresentativeItem.Phone}
      </Typography>
      <ListItemSecondaryAction className={classes.listItemSecondaryAction}>
        <IconButton
          aria-label="Remove"
          onClick={onRemove}
          tooltipContent="Remove"
          disabled={disabled}
        >
          <IconCross className={classes.iconCross} />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

OrderInformationSalesRepresentativeField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.number,
  }).isRequired,
  'Sales Representative': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
    'First Name': PropTypes.string.isRequired,
    'Last Name': PropTypes.string.isRequired,
    Email: PropTypes.string,
    Phone: PropTypes.string.isRequired,
  })).isRequired,
  onRemove: PropTypes.func,
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    listItemSecondaryAction: PropTypes.string.isRequired,
    iconCross: PropTypes.string.isRequired,
    typographyName: PropTypes.string.isRequired,
  }).isRequired,
};

OrderInformationSalesRepresentativeField.defaultProps = {
  onRemove: () => {},
  disabled: false,
};

export default withStyles(styles)(OrderInformationSalesRepresentativeField);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationSalesRepresentative/OrderInformationSalesRepresentativeField.js